import { render, staticRenderFns } from "./ax-date-field.vue?vue&type=template&id=146e221f&"
import script from "./ax-date-field.vue?vue&type=script&lang=js&"
export * from "./ax-date-field.vue?vue&type=script&lang=js&"
import style0 from "./ax-date-field.vue?vue&type=style&index=0&id=146e221f&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports